/* ============================================================
   profile.js — Profil public extins (modul dedicat, scalabil)
   Scripturi clasice (fără import/export), partajează scope-ul global.
   Datele extinse se stochează în club_settings 'profile_prefs'[userId]
   (fără coloane noi în Supabase) și se încarcă în hydrate.
   Funcțiile de aici sunt apelate din supabase-integration.js
   (renderMyProfile / openPlayerProfile / updateMyProfile / hydrate).
   ============================================================ */

/* ---------- Opțiuni ---------- */
window.PROFILE_GAME_TYPES = [
    'Eurogame', 'Ameritrash', 'Party', 'Cooperativ', 'Strategie', 'Filler',
    'Legacy', 'Deck Building', 'RPG', 'Worker Placement', 'Engine Building'
];
window.PROFILE_GENDERS = [
    { v: 'male', k: 'gender.male' },
    { v: 'female', k: 'gender.female' },
    { v: 'other', k: 'gender.other' },
    { v: 'na', k: 'gender.na' }
];
window.PROFILE_STATUS = [
    { v: '', k: 'pstatus.none' },
    { v: 'seeking_club', k: 'pstatus.seekingClub' },
    { v: 'seeking_cofounders', k: 'pstatus.seekingCofounders' },
    { v: 'open_to_invites', k: 'pstatus.openInvites' },
    { v: 'custom', k: 'pstatus.custom' }
];
window.PROFILE_DAYS = [
    { v: 'mon', k: 'day.mon' }, { v: 'tue', k: 'day.tue' }, { v: 'wed', k: 'day.wed' },
    { v: 'thu', k: 'day.thu' }, { v: 'fri', k: 'day.fri' }, { v: 'sat', k: 'day.sat' }, { v: 'sun', k: 'day.sun' }
];
window.PROFILE_SLOTS = [
    { v: 'morning', k: 'slot.morning' }, { v: 'afternoon', k: 'slot.afternoon' }, { v: 'evening', k: 'slot.evening' }
];
/* Țări (cod ISO + nume). Listă curată, România prima. */
window.PROFILE_COUNTRIES = [
    'RO', 'MD', 'GB', 'US', 'DE', 'FR', 'IT', 'ES', 'PT', 'NL', 'BE', 'AT', 'CH', 'IE',
    'DK', 'SE', 'NO', 'FI', 'IS', 'PL', 'CZ', 'SK', 'HU', 'BG', 'GR', 'HR', 'SI', 'RS',
    'UA', 'TR', 'CA', 'MX', 'BR', 'AR', 'AU', 'NZ', 'JP', 'KR', 'CN', 'IN', 'ZA', 'AE', 'IL', 'Other'
];
window.PROFILE_COUNTRY_NAMES = {
    RO: 'România', MD: 'Republica Moldova', GB: 'United Kingdom', US: 'United States', DE: 'Germany',
    FR: 'France', IT: 'Italy', ES: 'Spain', PT: 'Portugal', NL: 'Netherlands', BE: 'Belgium', AT: 'Austria',
    CH: 'Switzerland', IE: 'Ireland', DK: 'Denmark', SE: 'Sweden', NO: 'Norway', FI: 'Finland', IS: 'Iceland',
    PL: 'Poland', CZ: 'Czechia', SK: 'Slovakia', HU: 'Hungary', BG: 'Bulgaria', GR: 'Greece', HR: 'Croatia',
    SI: 'Slovenia', RS: 'Serbia', UA: 'Ukraine', TR: 'Türkiye', CA: 'Canada', MX: 'Mexico', BR: 'Brazil',
    AR: 'Argentina', AU: 'Australia', NZ: 'New Zealand', JP: 'Japan', KR: 'South Korea', CN: 'China',
    IN: 'India', ZA: 'South Africa', AE: 'UAE', IL: 'Israel'
};
/* Orașe sugerate (datalist) pentru câteva țări; restul = text liber. */
window.PROFILE_CITIES = {
    RO: ['București', 'Cluj-Napoca', 'Timișoara', 'Iași', 'Constanța', 'Brașov', 'Craiova', 'Sibiu',
         'Oradea', 'Arad', 'Pitești', 'Ploiești', 'Galați', 'Bacău', 'Baia Mare', 'Târgu Mureș',
         'Suceava', 'Brăila', 'Buzău', 'Satu Mare', 'Râmnicu Vâlcea'],
    MD: ['Chișinău', 'Bălți', 'Tiraspol', 'Cahul', 'Orhei'],
    GB: ['London', 'Manchester', 'Birmingham', 'Edinburgh', 'Glasgow', 'Bristol', 'Leeds'],
    US: ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Seattle', 'Austin', 'Boston', 'Denver']
};

/* ---------- XP Global + Nivel de experiență (din istoricul de meciuri) ----------
   ELO e strict local (pe club), deci nivelul de experiență din profil NU mai e
   legat de ELO. Folosim un XP global, calculat din meciuri jucate + câștigate:
     XP = meciuri * 10 + victorii * 25
   Volumul de joc e baza (10 XP / meci), iar victoria adaugă un bonus accelerat
   (+25 XP), deci o victorie valorează 35 XP, o înfrângere 10 XP.
   Pragurile sunt setate astfel încât „Expert" să ceară volum real de joc
   (~115 meciuri chiar la 100% win rate), nu câteva meciuri norocoase. */
window.PROFILE_XP_LEVELS = [
    { key: 'exp.novice',       min: 0 },
    { key: 'exp.intermediate', min: 500 },
    { key: 'exp.advanced',     min: 1500 },
    { key: 'exp.expert',       min: 4000 }
];
window.PROFILE_XP_PER_MATCH = 10;
window.PROFILE_XP_PER_WIN = 25;

/* Calcul pur: din nr. de meciuri și victorii -> { xp, key, levelIndex, floor, nextThreshold } */
window.profileXpInfo = function (matches, wins) {
    matches = Math.max(0, Number(matches) || 0);
    wins = Math.max(0, Number(wins) || 0);
    if (wins > matches) wins = matches;
    var xp = matches * window.PROFILE_XP_PER_MATCH + wins * window.PROFILE_XP_PER_WIN;
    var L = window.PROFILE_XP_LEVELS;
    var idx = 0;
    for (var i = 0; i < L.length; i++) { if (xp >= L[i].min) idx = i; }
    var next = (idx < L.length - 1) ? L[idx + 1].min : null;
    return { xp: xp, key: L[idx].key, levelIndex: idx, floor: L[idx].min, nextThreshold: next };
};

/* Nivel de experiență pentru un jucător (după nume).
   - Pentru userul curent, dacă există statistici globale calculate
     (window._profileGlobalStats), folosim XP-ul GLOBAL real (toate cluburile).
   - Altfel, derivăm din meciurile încărcate în state.games (clubul curent). */
window.profileExperienceLevel = function (idOrName) {
    var matches = 0, wins = 0;
    /* Rezolvă la id (acceptă id sau nume); participants/winners sunt pe id. */
    var mm = (state.membersById && state.membersById[idOrName]) || (state.members && state.members[idOrName]) || null;
    var id = (mm && mm.dbId) || idOrName;
    try {
        var g = window._profileGlobalStats;
        var ps = null;
        try { ps = (typeof _playerStatsById !== 'undefined' && _playerStatsById) ? _playerStatsById[id] : null; } catch (e2) { ps = null; }
        if (g && !g.error && !g.empty && typeof g.matches === 'number'
            && state.currentUser && id === state.currentUser.id) {
            // userul curent: XP global real (toate cluburile)
            matches = g.matches; wins = g.wins || 0;
        } else if (ps && typeof ps.matches === 'number') {
            // alt jucător: statistici GLOBALE din player_public_stats (consistent cu profilul propriu)
            matches = ps.matches; wins = ps.wins || 0;
        } else {
            // fallback: meciurile din clubul curent (dacă nu avem statistici globale încărcate)
            (state.games || []).forEach(function (s) {
                var players = Array.isArray(s.participants) ? s.participants : [];
                if (players.indexOf(id) === -1) return;
                matches++;
                var winners = Array.isArray(s.winners) ? s.winners : [];
                if (winners.indexOf(id) !== -1) wins++;
            });
        }
    } catch (e) { logError('top', e); }
    var info = window.profileXpInfo(matches, wins);
    return { key: info.key, xp: info.xp, levelIndex: info.levelIndex, nextThreshold: info.nextThreshold };
};

/* ---------- Utilitare ---------- */
function _pfEsc(s) { return window.escHtml(s); }
function _pfExtra(srcObj) {
    var e = (srcObj && srcObj.profileExtra && typeof srcObj.profileExtra === 'object') ? srcObj.profileExtra : {};
    return {
        age: e.age || '',
        gender: e.gender || '',
        gameTypes: Array.isArray(e.gameTypes) ? e.gameTypes : [],
        country: e.country || '',
        city: e.city || '',
        statusKind: e.statusKind || '',
        statusText: e.statusText || '',
        availability: (e.availability && typeof e.availability === 'object') ? e.availability : {},
        dmPolicy: (e.dmPolicy === 'friends' || e.dmPolicy === 'none') ? e.dmPolicy : 'all',
        presence: (e.presence === 'none') ? 'none' : 'all',   /* v9 8.14: doar 'none' ascunde (ca pe server) */
        vis: (e.vis && typeof e.vis === 'object') ? e.vis : {}
    };
}
function _visPill(field, on) {
    var T = window.t;
    return '<label class="pf-vis' + (on ? ' is-on' : '') + '" title="' + T('pf.visHint') + '">'
        + '<input type="checkbox" id="pfVis_' + field + '" ' + (on ? 'checked' : '') + ' onchange="this.closest(\'.pf-vis\').classList.toggle(\'is-on\', this.checked)">'
        + '<i class="fas fa-eye pf-eye-on"></i><i class="fas fa-eye-slash pf-eye-off"></i>'
        + ' <span class="pf-vis-on">' + T('pf.public') + '</span><span class="pf-vis-off">' + T('pf.notPublic') + '</span></label>';
}
function _rowHead(labelHtml, field, visOn) {
    return '<div style="display:flex; align-items:center; gap:8px; flex-wrap:wrap; margin-bottom:6px;">'
        + '<span class="form-section-label" style="margin:0;">' + labelHtml + '</span>' + _visPill(field, visOn) + '</div>';
}

/* ---------- Editor (în „Profilul meu") ---------- */
window.profileBuildEditorHTML = function () {
    var T = window.t;
    var u = (state.currentUser && state.currentUser.email && state.users[state.currentUser.email]) || {};
    var m = (state.currentUser && ((typeof memberById === 'function' && memberById(state.currentUser.id)) || state.members[state.currentUser.name])) || {};
    var src = (u.profileExtra ? u : (m.profileExtra ? m : u));
    var d = _pfExtra(src);
    var vis = d.vis || {};
    var cityVis = (typeof vis.city === 'boolean') ? vis.city : !!vis.location;
    var exp = window.profileExperienceLevel(state.currentUser ? state.currentUser.id : '');

    var genderOpts = '<option value="">—</option>' + window.PROFILE_GENDERS.map(function (g) {
        return '<option value="' + g.v + '" ' + (d.gender === g.v ? 'selected' : '') + '>' + T(g.k) + '</option>';
    }).join('');

    var typeChips = window.PROFILE_GAME_TYPES.map(function (gt) {
        var on = d.gameTypes.indexOf(gt) !== -1;
        return '<label style="display:inline-flex; align-items:center; gap:6px; font-weight:normal; font-size:0.85em; background:var(--bg-secondary); border:1px solid var(--border); border-radius:16px; padding:5px 10px; cursor:pointer;">'
            + '<input type="checkbox" class="pfGT" value="' + _pfEsc(gt) + '" ' + (on ? 'checked' : '') + '> ' + _pfEsc(gt) + '</label>';
    }).join('');

    var countryOpts = '<option value="">—</option>' + window.PROFILE_COUNTRIES.map(function (c) {
        var nm = c === 'Other' ? T('country.other') : (window.PROFILE_COUNTRY_NAMES[c] || c);
        return '<option value="' + c + '" ' + (d.country === c ? 'selected' : '') + '>' + _pfEsc(nm) + '</option>';
    }).join('');
    var allCities = [];
    Object.keys(window.PROFILE_CITIES).forEach(function (k) { allCities = allCities.concat(window.PROFILE_CITIES[k]); });
    var cityList = allCities.map(function (c) { return '<option value="' + _pfEsc(c) + '">'; }).join('');

    var statusOpts = window.PROFILE_STATUS.map(function (s) {
        return '<option value="' + s.v + '" ' + (d.statusKind === s.v ? 'selected' : '') + '>' + T(s.k) + '</option>';
    }).join('');

    var availRows = window.PROFILE_DAYS.map(function (day) {
        var slots = (d.availability && Array.isArray(d.availability[day.v])) ? d.availability[day.v] : [];
        var boxes = window.PROFILE_SLOTS.map(function (sl) {
            var on = slots.indexOf(sl.v) !== -1;
            return '<label style="display:inline-flex; align-items:center; gap:5px; font-weight:normal; font-size:0.8em; cursor:pointer;">'
                + '<input type="checkbox" class="pfAvail" data-day="' + day.v + '" value="' + sl.v + '" ' + (on ? 'checked' : '') + '> ' + T(sl.k) + '</label>';
        }).join('');
        return '<div style="display:flex; align-items:center; gap:10px; flex-wrap:wrap; padding:4px 0;">'
            + '<span style="min-width:84px; font-size:0.85em; color:var(--text-secondary);">' + T(day.k) + '</span>' + boxes + '</div>';
    }).join('');

    return ''
    + '<h3 style="margin:22px 0 12px;"><i class="fas fa-id-badge"></i> ' + T('pf.publicTitle') + '</h3>'
    + '<p style="color:var(--text-secondary); font-size:0.85em; margin-bottom:14px;">' + T('pf.publicIntro') + '</p>'

    /* Experiență (read-only, derivat din XP global) */
    + '<div class="form-group">'
    +   _rowHead('<i class="fas fa-medal"></i> ' + T('pf.experience'), 'experience', vis.experience !== false)
    +   '<div style="margin-top:6px;"><span class="badge badge-primary" style="font-size:0.9em;">' + T(exp.key) + '</span> '
    +     '<small style="color:var(--text-secondary);">' + T('pf.experienceNote') + '</small></div>'
    + '</div>'

    /* Vârstă + gen */
    + '<div class="form-row">'
    +   '<div class="form-group">'
    +     _rowHead('<i class="fas fa-cake-candles"></i> ' + T('pf.age'), 'age', !!vis.age)
    +     '<input type="number" id="pfAge" class="form-control" min="6" max="120" value="' + _pfEsc(d.age) + '" placeholder="' + T('profile.optional') + '">'
    +   '</div>'
    +   '<div class="form-group">'
    +     _rowHead('<i class="fas fa-venus-mars"></i> ' + T('pf.gender'), 'gender', !!vis.gender)
    +     '<select id="pfGender" class="form-control">' + genderOpts + '</select>'
    +   '</div>'
    + '</div>'

    /* Tipuri de jocuri preferate (compact: pliat implicit, păstrează multi-select-ul) */
    + '<div class="form-group">'
    +   _rowHead('<i class="fas fa-dice"></i> ' + T('pf.gameTypes'), 'gameTypes', !!vis.gameTypes)
    +   '<details style="margin-top:6px;"><summary style="cursor:pointer; color:var(--text-secondary); font-size:0.88em; user-select:none; padding:6px 0;">'
    +     '<i class="fas fa-chevron-down" style="font-size:0.8em; margin-right:6px;"></i>' + T('pf.gameTypesChoose')
    +     ' (' + d.gameTypes.length + ')</summary>'
    +   '<div style="display:flex; flex-wrap:wrap; gap:8px; margin-top:8px;">' + typeChips + '</div></details>'
    + '</div>'

    /* Locație */
    + '<div class="form-row">'
    +   '<div class="form-group">'
    +     _rowHead('<i class="fas fa-flag"></i> ' + T('pf.country'), 'location', !!vis.location)
    +     '<select id="pfCountry" class="form-control">' + countryOpts + '</select>'
    +   '</div>'
    +   '<div class="form-group">'
    +     _rowHead('<i class="fas fa-location-dot"></i> ' + T('pf.city'), 'city', cityVis)
    +     '<div class="geo-city-wrap">'
    +       '<input type="text" id="pfCity" class="form-control" autocomplete="off" value="' + _pfEsc(d.city) + '" placeholder="' + T('pf.cityPh') + '" oninput="geoCitySearch(\'pfCity\',\'pfCityResults\',\'pfCountry\',\'\')" onblur="geoCityHide(\'pfCityResults\')">'
    +       '<div id="pfCityResults" class="geo-city-results" style="display:none;"></div>'
    +     '</div>'
    +   '</div>'
    + '</div>'

    /* Status social */
    + '<div class="form-group">'
    +   _rowHead('<i class="fas fa-bullhorn"></i> ' + T('pf.status'), 'status', !!vis.status)
    +   '<select id="pfStatusKind" class="form-control" onchange="profileToggleStatusText()">' + statusOpts + '</select>'
    +   '<input type="text" id="pfStatusText" class="form-control" style="margin-top:8px; ' + (d.statusKind === 'custom' ? '' : 'display:none;') + '" maxlength="120" value="' + _pfEsc(d.statusText) + '" placeholder="' + T('pf.statusPh') + '">'
    + '</div>'

    /* Disponibilitate (pliabilă, ca să nu ocupe tot ecranul) */
    + '<div class="form-group">'
    +   _rowHead('<i class="fas fa-calendar-week"></i> ' + T('pf.availability'), 'availability', !!vis.availability)
    +   '<details style="margin-top:6px; border:1px solid var(--border); border-radius:10px; padding:8px 12px; background:var(--bg-secondary);">'
    +     '<summary style="cursor:pointer; color:var(--text-secondary); font-size:0.9em; user-select:none;">' + T('pf.availabilityToggle') + '</summary>'
    +     '<div style="margin-top:8px;">' + availRows + '</div>'
    +   '</details>'
    + '</div>'

    /* Cine îmi poate trimite mesaje (setare, nu câmp public) */
    + '<div class="form-group">'
    +   '<label for="pfDmPolicy"><i class="fas fa-comment-dots"></i> ' + T('dm.policy') + '</label>'
    +   '<select id="pfDmPolicy" class="form-control">'
    +     '<option value="all" ' + (d.dmPolicy === 'all' ? 'selected' : '') + '>' + T('dm.policyAll') + '</option>'
    +     '<option value="friends" ' + (d.dmPolicy === 'friends' ? 'selected' : '') + '>' + T('dm.policyFriendsOpt') + '</option>'
    +     '<option value="none" ' + (d.dmPolicy === 'none' ? 'selected' : '') + '>' + T('dm.policyNoneOpt') + '</option>'
    +   '</select>'
    + '</div>'

    /* v9 8.14: cine vede când sunt online (setare, nu câmp public). D19: Toți / Nimeni,
       reciproc — explicat sub listă, ca omul să știe că nici el nu-i mai vede pe alții. */
    + '<div class="form-group">'
    +   '<label for="pfPresence"><i class="fas fa-circle" style="color:var(--success, #27ae60); font-size:.7em; vertical-align:middle;" aria-hidden="true"></i> ' + T('pres.setting') + '</label>'
    +   '<select id="pfPresence" class="form-control" aria-describedby="pfPresenceHint">'
    +     '<option value="all" ' + (d.presence !== 'none' ? 'selected' : '') + '>' + T('pres.all') + '</option>'
    +     '<option value="none" ' + (d.presence === 'none' ? 'selected' : '') + '>' + T('pres.none') + '</option>'
    +   '</select>'
    +   '<small id="pfPresenceHint" style="display:block; margin-top:6px; color:var(--text-secondary);">' + T('pres.hint') + '</small>'
    + '</div>'
    + (typeof window.profileBuildSpaceCardHTML === 'function' ? window.profileBuildSpaceCardHTML() : '');
};

window.profileToggleStatusText = function () {
    var k = document.getElementById('pfStatusKind');
    var t = document.getElementById('pfStatusText');
    if (k && t) t.style.display = (k.value === 'custom') ? '' : 'none';
};

/* ---------- Citire din editor (apelat de updateMyProfile) ---------- */
window.profileCollectEditor = function () {
    function val(id) { var el = document.getElementById(id); return el ? el.value : ''; }
    var gameTypes = Array.prototype.map.call(document.querySelectorAll('.pfGT:checked'), function (c) { return c.value; });
    var availability = {};
    Array.prototype.forEach.call(document.querySelectorAll('.pfAvail:checked'), function (c) {
        var day = c.getAttribute('data-day'); if (!availability[day]) availability[day] = [];
        availability[day].push(c.value);
    });
    function vis(f) { var el = document.getElementById('pfVis_' + f); return el ? !!el.checked : false; }
    var ageNum = parseInt(val('pfAge'), 10);
    return {
        age: (!isNaN(ageNum) && ageNum > 0) ? ageNum : '',
        gender: val('pfGender'),
        gameTypes: gameTypes,
        country: val('pfCountry'),
        city: (val('pfCity') || '').trim(),
        statusKind: val('pfStatusKind'),
        statusText: (val('pfStatusText') || '').trim(),
        availability: availability,
        dmPolicy: val('pfDmPolicy') || 'all',
        presence: (val('pfPresence') === 'none') ? 'none' : 'all',   /* v9 8.14 */
        vis: {
            age: vis('age'), gender: vis('gender'), gameTypes: vis('gameTypes'),
            location: vis('location'), city: vis('city'), status: vis('status'),
            availability: vis('availability'), experience: vis('experience'),
            favGames: (document.getElementById('pfVis_favGames') ? !!document.getElementById('pfVis_favGames').checked : true)
        }
    };
};

/* ---------- Randare în profilul PUBLIC (respectă vizibilitatea) ---------- */
window.profileRenderPublic = function (m) {
    if (!m) return '';
    var T = window.t;
    var d = _pfExtra(m);
    var vis = d.vis || {};
    var out = [];

    /* ⚠ SURSA COMUNA pentru varsta, gen, locatie si tipuri de joc — o folosesc si
         profilul de club, si cel public. De aceea garda de blocare sta AICI, nu in
         fiecare modal: filtrasem doar profilul public si datele continuau sa apara
         in celalalt, plus varsta/genul/locatia ramaneau in amandoua.
       ⚠ NIVELUL DE EXPERIENTA se pastreaza: e o statistica derivata din sesiuni,
         nu o data personala, iar regula convenita e „raman numele si statisticile".
       EN: single source for the public detail rows; the block guard belongs here. */
    var _blkId = m.id || m.dbId || null;
    var _blocat = !!(_blkId && typeof window.isBlockedPair === 'function' && window.isBlockedPair(_blkId));
    if (_blocat) {
        if (vis.experience !== false) {
            var _e = window.profileExperienceLevel(_blkId || m.name || '');
            out.push(_pubRow('fa-medal', T('pf.experience'), '<span class="badge badge-primary" style="font-size:.8em;">' + T(_e.key) + '</span>'));
        }
        /* ⚠ ACELASI invelis ca la iesirea normala de mai jos (chenar + spatiere).
             O clasa inventata ar fi lasat randul fara stiluri. */
        if (!out.length) return '';
        return '<div style="border-top:1px solid var(--border); margin-top:12px; padding-top:12px; display:flex; flex-direction:column; gap:10px;">' + out.join('') + '</div>';
    }

    if (vis.experience !== false) {
        var exp = window.profileExperienceLevel(m.id || m.dbId || m.name || '');
        out.push(_pubRow('fa-medal', T('pf.experience'), '<span class="badge badge-primary" style="font-size:.8em;">' + T(exp.key) + '</span>'));
    }
    if (vis.age && d.age) out.push(_pubRow('fa-cake-candles', T('pf.age'), _pfEsc(d.age)));
    if (vis.gender && d.gender) {
        var g = window.PROFILE_GENDERS.filter(function (x) { return x.v === d.gender; })[0];
        out.push(_pubRow('fa-venus-mars', T('pf.gender'), g ? T(g.k) : _pfEsc(d.gender)));
    }
    var cityVisP = (typeof vis.city === 'boolean') ? vis.city : !!vis.location;
    var locParts = [];
    if (cityVisP && d.city) locParts.push(_pfEsc(d.city));
    if (vis.location && d.country) {
        var cn = d.country === 'Other' ? T('country.other') : (window.PROFILE_COUNTRY_NAMES[d.country] || d.country);
        locParts.push(_pfEsc(cn));
    }
    if (locParts.length) out.push(_pubRow('fa-location-dot', T('pf.location'), locParts.join(', ')));
    if (vis.gameTypes && d.gameTypes.length) {
        var chips = d.gameTypes.map(function (gt) { return '<span class="badge badge-primary" style="font-size:.78em;">' + _pfEsc(gt) + '</span>'; }).join(' ');
        out.push(_pubRow('fa-dice', T('pf.gameTypes'), '<span style="display:inline-flex; flex-wrap:wrap; gap:4px;">' + chips + '</span>'));
    }
    if (vis.status && (d.statusKind || d.statusText)) {
        var st;
        if (d.statusKind === 'custom') st = _pfEsc(d.statusText);
        else { var so = window.PROFILE_STATUS.filter(function (x) { return x.v === d.statusKind; })[0]; st = so && so.v ? T(so.k) : ''; }
        if (st) out.push(_pubRow('fa-bullhorn', T('pf.status'), st));
    }
    if (vis.availability && d.availability && Object.keys(d.availability).length) {
        var parts = window.PROFILE_DAYS.filter(function (day) { return d.availability[day.v] && d.availability[day.v].length; })
            .map(function (day) {
                var slots = d.availability[day.v].map(function (sv) {
                    var s = window.PROFILE_SLOTS.filter(function (x) { return x.v === sv; })[0];
                    return s ? T(s.k) : sv;
                }).join(', ');
                return '<div style="font-size:.85em;"><strong>' + T(day.k) + ':</strong> ' + slots + '</div>';
            }).join('');
        if (parts) out.push(_pubRow('fa-calendar-week', T('pf.availability'), '<div style="margin-top:4px;">' + parts + '</div>'));
    }

    if (!out.length) return '';
    return '<div style="border-top:1px solid var(--border); margin-top:12px; padding-top:12px; display:flex; flex-direction:column; gap:10px;">' + out.join('') + '</div>';
};
function _pubRow(icon, label, valueHtml) {
    return '<div><div style="font-size:.78em; color:var(--text-secondary); margin-bottom:2px;"><i class="fas ' + icon + '"></i> ' + label + '</div><div>' + valueHtml + '</div></div>';
}

/* ---------- Locație club: editor + colectare (din setările clubului) ---------- */
window.clubLocationEditorHTML = function (c) {
    var T = window.t;
    var loc = (c && c.location && typeof c.location === 'object') ? c.location : {};
    var countryOpts = '<option value="">—</option>' + window.PROFILE_COUNTRIES.map(function (cc) {
        var nm = cc === 'Other' ? T('country.other') : (window.PROFILE_COUNTRY_NAMES[cc] || cc);
        return '<option value="' + cc + '" ' + (loc.country === cc ? 'selected' : '') + '>' + _pfEsc(nm) + '</option>';
    }).join('');
    var allCities = [];
    Object.keys(window.PROFILE_CITIES).forEach(function (k) { allCities = allCities.concat(window.PROFILE_CITIES[k]); });
    var cityList = allCities.map(function (c2) { return '<option value="' + _pfEsc(c2) + '">'; }).join('');
    return '<div class="form-group">'
        + '<label for="clubCountry"><i class="fas fa-map-location-dot"></i> ' + T('clubset.location') + '</label>'
        + '<div class="form-row">'
        +   '<select id="clubCountry" class="form-control">' + countryOpts + '</select>'
        +   '<div class="geo-city-wrap"><input type="text" id="clubCity" class="form-control" autocomplete="off" value="' + _pfEsc(loc.city || '') + '" placeholder="' + T('pf.city') + '" oninput="geoCitySearch(\'clubCity\',\'clubCityResults\',\'clubCountry\',\'\')" onblur="geoCityHide(\'clubCityResults\')"><div id="clubCityResults" class="geo-city-results" style="display:none;"></div></div>'
        + '</div>'
        + '<input type="text" id="clubPlace" class="form-control" style="margin-top:8px;" maxlength="160" value="' + _pfEsc(loc.place || '') + '" placeholder="' + T('clubset.placePh') + '">'
        + '</div>';
};
window.clubLocationCollect = function () {
    function val(id) { var el = document.getElementById(id); return el ? (el.value || '').trim() : ''; }
    var country = val('clubCountry'), city = val('clubCity'), place = val('clubPlace');
    if (!country && !city && !place) return null;
    return { country: country, city: city, place: place };
};
window.clubLocationText = function (loc) {
    if (!loc || typeof loc !== 'object') return '';
    var T = window.t;
    var cn = loc.country === 'Other' ? T('country.other') : (window.PROFILE_COUNTRY_NAMES[loc.country] || loc.country || '');
    return [loc.place, loc.city, cn].filter(Boolean).join(', ');
};

/* ============================================================
   ===== SPAȚIU FIZIC (board game nights) — Batch 2 ===========
   PII sensibil (adresa) stocat în tabel separat `profile_spaces`
   (NU în profile_extra, care e larg lizibil). Citirea altor useri
   se face DOAR prin RPC `profile_spaces_for` gated pe vizibilitate
   (public / cluburile mele / prieteni / nu afișa). RO+EN, escapare.
   ============================================================ */
window._mySpace = window._mySpace || null;

/* Selector de vizibilitate pe 4 niveluri (înlocuiește pill-ul binar pt. câmpurile spațiului). */
function _visSelect(field, value) {
    var T = window.t;
    var v = (value === 'public' || value === 'clubs' || value === 'friends') ? value : 'none';
    function opt(val, key) { return '<option value="' + val + '"' + (v === val ? ' selected' : '') + '>' + T(key) + '</option>'; }
    return '<select id="pfVisSel_' + field + '" class="form-control pf-vis-select" style="margin-top:4px;">'
        + opt('public', 'space.visPublic') + opt('clubs', 'space.visClubs')
        + opt('friends', 'space.visFriends') + opt('none', 'space.visNone') + '</select>';
}

window.profileBuildSpaceCardHTML = function () {
    var T = window.t;
    var s = (window._mySpace && typeof window._mySpace === 'object') ? window._mySpace : {};
    var has = !!s.has_space;
    var cap = (s.capacity != null && s.capacity !== '') ? s.capacity : '';
    var addr = s.address || '';
    var visSpace = s.vis_space || 'none';
    var visAddr = s.vis_address || 'none';
    return ''
    + '<h3 style="margin:24px 0 12px;"><i class="fas fa-house-chimney"></i> ' + T('space.title') + '</h3>'
    + '<p style="color:var(--text-secondary); font-size:0.85em; margin-bottom:12px;">' + T('space.intro') + '</p>'
    + '<div class="form-group">'
    +   '<label style="display:flex; align-items:center; gap:10px; cursor:pointer; margin:0;">'
    +     '<input type="checkbox" id="pfHasSpace" ' + (has ? 'checked' : '') + ' onchange="profileToggleSpace()"> '
    +     '<span>' + T('space.question') + '</span></label>'
    + '</div>'
    + '<div id="pfSpaceDetails" style="' + (has ? '' : 'display:none;') + '">'
    +   '<div class="form-group">'
    +     '<label for="pfSpaceCapacity"><i class="fas fa-users"></i> ' + T('space.capacity') + '</label>'
    +     '<input type="number" id="pfSpaceCapacity" class="form-control" min="1" max="999" value="' + _pfEsc(cap) + '" placeholder="' + T('space.capacityPh') + '">'
    +     '<div style="margin-top:8px;"><small style="color:var(--text-secondary);"><i class="fas fa-eye"></i> ' + T('space.visSpaceLabel') + '</small>' + _visSelect('space', visSpace) + '</div>'
    +   '</div>'
    +   '<div class="form-group">'
    +     '<label for="pfSpaceAddress"><i class="fas fa-map-location-dot"></i> ' + T('space.address') + '</label>'
    +     '<input type="text" id="pfSpaceAddress" class="form-control" maxlength="200" value="' + _pfEsc(addr) + '" placeholder="' + T('space.addressPh') + '">'
    +     '<div style="margin-top:8px;"><small style="color:var(--text-secondary);"><i class="fas fa-eye"></i> ' + T('space.visAddressLabel') + '</small>' + _visSelect('address', visAddr) + '</div>'
    +     '<p style="color:var(--text-secondary); font-size:0.78em; margin-top:8px;"><i class="fas fa-shield-halved"></i> ' + T('space.addressNote') + '</p>'
    +   '</div>'
    + '</div>';
};

window.profileToggleSpace = function () {
    var c = document.getElementById('pfHasSpace');
    var d = document.getElementById('pfSpaceDetails');
    if (c && d) d.style.display = c.checked ? '' : 'none';
};

/* Încarcă rândul propriu din profile_spaces și completează inputurile editorului. */
window.profileLoadMySpace = async function () {
    if (typeof sb === 'undefined' || !sb || !state.currentUser || !state.currentUser.id) return;
    if (typeof isDemoMode === 'function' && isDemoMode()) return;
    try {
        var res = await sb.from('profile_spaces').select('*').eq('user_id', state.currentUser.id).maybeSingle();
        var s = (res && res.data) ? res.data : { has_space: false, capacity: null, address: '', vis_space: 'none', vis_address: 'none' };
        window._mySpace = s;
        var c = document.getElementById('pfHasSpace'); if (c) c.checked = !!s.has_space;
        var det = document.getElementById('pfSpaceDetails'); if (det) det.style.display = s.has_space ? '' : 'none';
        var cap = document.getElementById('pfSpaceCapacity'); if (cap) cap.value = (s.capacity != null ? s.capacity : '');
        var addr = document.getElementById('pfSpaceAddress'); if (addr) addr.value = s.address || '';
        var vs = document.getElementById('pfVisSel_space'); if (vs) vs.value = s.vis_space || 'none';
        var va = document.getElementById('pfVisSel_address'); if (va) va.value = s.vis_address || 'none';
    } catch (e) { console.warn('profileLoadMySpace:', e && e.message); }
};

window.profileCollectSpace = function () {
    function val(id) { var el = document.getElementById(id); return el ? el.value : ''; }
    var has = !!(document.getElementById('pfHasSpace') && document.getElementById('pfHasSpace').checked);
    var capNum = parseInt(val('pfSpaceCapacity'), 10);
    function visv(f) { var el = document.getElementById('pfVisSel_' + f); var v = el ? el.value : 'none'; return (v === 'public' || v === 'clubs' || v === 'friends') ? v : 'none'; }
    return {
        has_space: has,
        capacity: (has && !isNaN(capNum) && capNum > 0) ? capNum : null,
        address: has ? (val('pfSpaceAddress') || '').trim() : '',
        vis_space: has ? visv('space') : 'none',
        vis_address: has ? visv('address') : 'none'
    };
};

/* Upsert în profile_spaces. Rulează DOAR dacă editorul (cardul) e în DOM,
   ca să nu suprascrie rândul când updateMyProfile e apelat din alt context. */
window.profileSaveSpace = async function () {
    if (typeof sb === 'undefined' || !sb || !state.currentUser || !state.currentUser.id) return;
    if (!document.getElementById('pfHasSpace')) return;
    if (typeof isDemoMode === 'function' && isDemoMode()) return;
    var s = window.profileCollectSpace();
    var row = {
        user_id: state.currentUser.id, has_space: s.has_space, capacity: s.capacity,
        address: s.address || null, vis_space: s.vis_space, vis_address: s.vis_address,
        updated_at: new Date().toISOString()
    };
    try {
        var r = await sb.from('profile_spaces').upsert(row, { onConflict: 'user_id' });
        if (r.error) { console.warn('profileSaveSpace:', r.error.message); return; }
        window._mySpace = row;
    } catch (e) { console.warn('profileSaveSpace:', e && e.message); }
};

/* Bloc pentru profilul public (pop-up Discover). `space` = ce a întors RPC-ul
   profile_spaces_for (deja gated pe vizibilitate). Adresa apare doar dacă RPC-ul a returnat-o. */
window.profileSpacePublicHtml = function (space) {
    if (!space || !space.has_space) return '';
    var T = window.t;
    var rows = [];
    var capTxt = (space.capacity != null && space.capacity !== '') ? (' <small style="color:var(--text-secondary);">· ' + T('space.upTo').replace('{n}', _pfEsc(space.capacity)) + '</small>') : '';
    rows.push('<div><span class="badge badge-primary" style="font-size:.8em; background:rgba(78,205,196,.18); color:#4ecdc4;"><i class="fas fa-house-chimney"></i> ' + T('space.hasSpace') + '</span>' + capTxt + '</div>');
    if (space.address) {
        rows.push('<div style="font-size:.88em;"><i class="fas fa-map-location-dot" style="opacity:.6;"></i> ' + _pfEsc(space.address) + '</div>');
    }
    return '<div style="border-top:1px solid var(--border); margin-top:12px; padding-top:12px; display:flex; flex-direction:column; gap:8px;">'
        + '<div style="font-size:.78em; color:var(--text-secondary);"><i class="fas fa-people-roof"></i> ' + T('space.sectionTitle') + '</div>'
        + rows.join('') + '</div>';
};

/* Badge compact pentru cardul de Discover (doar existența + capacitatea, fără adresă). */
window.profileSpaceBadgeHtml = function (space) {
    if (!space || !space.has_space) return '';
    var T = window.t;
    var cap = (space.capacity != null && space.capacity !== '') ? (' ' + _pfEsc(space.capacity)) : '';
    return '<span class="badge" style="font-size:1em; background:rgba(78,205,196,.18); color:#4ecdc4;" title="' + T('space.hasSpace') + '"><i class="fas fa-house-chimney"></i>' + cap + '</span>';
};

/* ============================================================
   ===== CĂUTARE LIVE ORAȘ (GeoNames via proxy) — Batch 3 =====
   Widget reutilizabil: input + dropdown de rezultate. Apelează
   Edge Function `geo-proxy` (username GeoNames = secret în env,
   Verify-JWT ON, rate limiting). Dacă proxy-ul nu e configurat
   (GEONAMES_USERNAME lipsă) -> { disabled:true } -> rămâne text liber
   (fallback grațios, fără eroare). Țările rămân listă fixă (set finit).
   ============================================================ */
window._geoTimer = null;

function _geoEsc(s) { return window.escHtml(s); }
function _geoAttr(s) { return (typeof window.attrJs === 'function') ? window.attrJs(s) : String(s == null ? '' : s).replace(/'/g, "\\'"); }
function _geoLabel(it) {
    var parts = [it.name];
    if (it.admin1 && it.admin1 !== it.name) parts.push(it.admin1);
    if (it.countryName) parts.push(it.countryName);
    return parts.filter(Boolean).join(', ');
}

window.geoCitySearch = function (inputId, resultsId, countryId, cb) {
    var inp = document.getElementById(inputId);
    var box = document.getElementById(resultsId);
    if (!inp || !box) return;
    var q = (inp.value || '').trim();
    clearTimeout(window._geoTimer);
    /* păstrează filtrarea pe text liber (Discover) la fiecare tastă */
    if (cb && window[cb]) { try { window[cb](); } catch (e) { logError('_geoLabel', e); } }
    if (q.length < 2) { box.innerHTML = ''; box.style.display = 'none'; return; }
    window._geoTimer = setTimeout(function () { _geoRun(inputId, resultsId, countryId, cb, q); }, 350);
};

async function _geoRun(inputId, resultsId, countryId, cb, q) {
    var box = document.getElementById(resultsId);
    if (!box) return;
    if (typeof sb === 'undefined' || !sb) return;
    if (typeof isDemoMode === 'function' && isDemoMode()) return;
    var country = '';
    if (countryId) { var ce = document.getElementById(countryId); country = (ce && ce.value && ce.value !== 'Other') ? ce.value : ''; }
    try {
        box.style.display = 'block';
        box.innerHTML = '<div class="geo-city-loading">' + window.t('geo.searching') + '</div>';
        var resp = await sb.functions.invoke('geo-proxy', { body: { type: 'city', q: q, country: country } });
        var data = resp && resp.data;
        var cur = document.getElementById(inputId);
        if (cur && (cur.value || '').trim() !== q) return; /* răspuns vechi */
        if (data && data.disabled) { box.style.display = 'none'; box.innerHTML = ''; return; } /* proxy nesetat -> text liber */
        var items = (data && data.items) || [];
        if (!items.length) { box.innerHTML = '<div class="geo-city-empty">' + window.t('geo.noResults') + '</div>'; return; }
        box.innerHTML = items.slice(0, 8).map(function (it) {
            var nameAttr = _geoAttr(it.name);
            var ccAttr = _geoAttr(it.countryCode || '');
            return '<div class="geo-city-item" onmousedown="event.preventDefault(); geoPickCity(\'' + inputId + '\',\'' + resultsId + '\',\'' + nameAttr + '\',\'' + (countryId || '') + '\',\'' + ccAttr + '\',\'' + (cb || '') + '\')">'
                + '<i class="fas fa-location-dot" style="opacity:.5;"></i> ' + _geoEsc(_geoLabel(it)) + '</div>';
        }).join('');
    } catch (e) {
        box.innerHTML = '<div class="geo-city-empty">' + window.t('geo.unavailable') + '</div>';
    }
}

window.geoPickCity = function (inputId, resultsId, name, countryId, cc, cb) {
    var inp = document.getElementById(inputId);
    if (inp) inp.value = name;
    /* dacă există un select de țară și nu e setat, completează-l din rezultat */
    if (countryId && cc) {
        var ce = document.getElementById(countryId);
        if (ce && (!ce.value || ce.value === 'Other')) {
            var has = Array.prototype.some.call(ce.options || [], function (o) { return o.value === cc; });
            if (has) ce.value = cc;
        }
    }
    var box = document.getElementById(resultsId);
    if (box) { box.innerHTML = ''; box.style.display = 'none'; }
    if (cb && window[cb]) { try { window[cb](); } catch (e) { logError('_geoRun', e); } }
};

window.geoCityHide = function (resultsId) {
    setTimeout(function () { var b = document.getElementById(resultsId); if (b) b.style.display = 'none'; }, 200);
};
